import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

export const SALES_TAX_ROOTUI_TYPE = 'SALES_TAX_MODAL';

import type { SalesTaxModalProps } from './types';

export const SalesTaxUpsertAction = createAction(rootUiActions.createDialog.toString(), (props: SalesTaxModalProps) =>
  rootUiTypes.mkRootUiData({
    type: SALES_TAX_ROOTUI_TYPE,
    props: ImmutableMap({
      modalType: props?.modalType || 'drawer',
      formComponentProps: props.formComponentProps,
      context: props?.context,
    }),
  }),
);
